import { defineComponent as c, inject as u, computed as a, openBlock as p, createElementBlock as x, mergeProps as w, renderSlot as b } from "vue";
import { tw as t } from "../../utils/tailwind.js";
import { listVariantInjectionKey as C } from "../List/List.constant.js";
const y = /* @__PURE__ */ c({
  name: "RevListItemBase",
  inheritAttrs: !1,
  __name: "ListItemBase",
  props: {
    wrapperAttrs: { default: () => ({}) },
    itemsCenter: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const s = u(C, null), l = a(() => [
      /**
       * overflow-clip is a new value for the `overflow` property that behaves like `hidden`
       * but does not create a new block formatting context.
       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#clip
       *
       * It also fixes the issue of `text-overflow: ellipsis` not working when the element
       * is not a block formatting context.
       * @see https://github.com/BackMarket/design-system-vue2/blame/caa1c06a2ebeeddbb4dfa79a5d0a92242f3a8def/src/components/List/ListItem/ListItem.vue#L344
       *
       * @note `clip` is supported in Chrome>90, FF>91, Safari>16
       */
      // ESLint rule incorrectly flagging overflow-clip. I meant to use `overflow`
      // and not `text-overflow`.
      t`overflow-clip supports-[not(overflow:clip)]:overflow-hidden`,
      t`body-2 flex w-full border-0 text-left no-underline duration-200 motion-safe:transition`,
      e.isDisabled ? t`bg-static-default-hi-disabled text-static-default-hi-disabled` : t`bg-static-default-min text-static-default-hi`,
      e.itemsCenter ? t`items-center` : t`items-start`,
      s?.value === "compact" ? t`py-8` : t`py-20`
    ]), i = [t`mr-8`], o = [t`body-1 w-full max-w-full`], r = a(() => [
      e.isDisabled ? t`text-static-default-low-disabled` : t`text-static-default-low`,
      t`w-full max-w-full`
    ]), n = a(() => [
      e.isDisabled ? t`text-static-default-low-disabled` : t`text-static-default-low`,
      t`ml-24 flex text-right`
    ]), d = [t`flex grow flex-col items-start`], f = a(() => [
      e.isDisabled ? t`text-static-default-mid-disabled` : t`text-static-default-mid`,
      t`text-caption leading-caption`
    ]);
    return (m, h) => (p(), x("li", w(e.wrapperAttrs, { class: "border-static-default-low relative list-none tap-highlight-transparent first:rounded-t-inherit last:rounded-b-inherit" }), [
      b(m.$slots, "default", {
        descriptionClassNames: r.value,
        labelClassNames: o,
        mainAreaClassNames: d,
        prefixClassNames: i,
        suffixClassNames: n.value,
        titleClassNames: f.value,
        wrapperClassNames: l.value
      })
    ], 16));
  }
});
export {
  y as default
};
